Vue.component('modal', {
    delimiters: ['[[', ']]'],
    mixins: [eventHubMixin],
    props: ['name'],
    data: () => {
      return {
        opened: false
      }
    },
    methods: {
    },
    mounted () {
      this.eventHub.$on(`modal:${this.name}:close`, () => {
        this.opened = false;
      })
      this.eventHub.$on(`modal:${this.name}:open`, (data) => {
        this.opened = true;
        this.$emit('open');
      })
    },
    template: `<transition name="fade">
    <div class="modal" v-show="opened" @click="opened=false">
        <div class="modal-inner" @click.stop>
            <button class="modal-close" @click="opened=false"><i class="icon-close"></i></button>
            <div class="modal-header">
                <h3 class="title"><slot name="header">default header</slot></h3>
            </div>
            <div class="modal-body">
                <slot name="body">
                </slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    default footer
                </slot>
            </div> 
        </div>
    </div>
</transition>`
  }) 